<template>
    <a :href="finalUrl" class="cards-main__link blue-btn">{{ finalText | trans }}</a>
</template>

<script>
export default {
    name: "GoToComplexesButton",
    props: {
        text: {
            type: String,
            default: 'View more'
        },
        url: {
            type: String,
            default: ''
        }
    },
    computed: {
        finalUrl() {
            return this.url || (this.$root.baseUrl + '/complexes');
        },
        finalText() {
            // for case when this.text is empty string
            return this.text || 'View more';
        }
    }
}
</script>
